import { rankings, type Comic } from '@/mocks/comics';
import SectionHeader from './SectionHeader';

interface RankingsProps {
  onSelect: (comic: Comic) => void;
}

const trendIcon: Record<string, { icon: string; color: string }> = {
  up: { icon: 'ri-arrow-up-line', color: 'text-primary-600' },
  down: { icon: 'ri-arrow-down-line', color: 'text-foreground-400' },
  flat: { icon: 'ri-arrow-right-line', color: 'text-accent-600' },
};

export default function Rankings({ onSelect }: RankingsProps) {
  return (
    <section id="rankings" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <SectionHeader
          kicker="人气排行榜"
          title="今日人气 TOP 10"
          desc="基于近 24 小时阅读、收藏与评分实时计算，每天 0 点准时刷新。锁定人气佳作，选漫不踩雷。"
        />
        <ol className="divide-y divide-background-200 rounded-2xl border border-background-200 bg-background-100 overflow-hidden">
          {rankings.map(({ rank, comic, change }) => {
            const t = trendIcon[change];
            return (
              <li key={comic.id}>
                <button
                  type="button"
                  onClick={() => onSelect(comic)}
                  className="flex w-full items-center gap-3 md:gap-4 px-4 md:px-6 py-3.5 md:py-4 text-left hover:bg-background-50 transition-colors cursor-pointer"
                >
                  <span
                    className={`w-8 h-8 md:w-9 md:h-9 shrink-0 flex items-center justify-center rounded-lg font-heading text-lg md:text-xl ${
                      rank <= 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
                    }`}
                  >
                    {rank}
                  </span>
                  <span className="hidden sm:block w-12 h-16 shrink-0 overflow-hidden rounded-md bg-background-200">
                    <img src={comic.cover} alt={`${comic.title}高清韩漫封面`} className="w-full h-full object-cover object-top" loading="lazy" />
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="flex items-center gap-2">
                      <span className="truncate font-semibold text-sm md:text-base text-foreground-950">{comic.title}</span>
                      <i className={`${t.icon} w-3.5 h-3.5 flex items-center justify-center shrink-0 ${t.color}`} />
                    </span>
                    <span className="mt-0.5 block truncate text-xs text-foreground-500">
                      {comic.category} · {comic.author} · {comic.chapterCount}话
                    </span>
                  </span>
                  <span className="hidden md:flex flex-wrap gap-1.5 justify-end">
                    {comic.tags.slice(0, 2).map((tag) => (
                      <span key={tag} className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-800 text-xs">
                        {tag}
                      </span>
                    ))}
                  </span>
                  <span className="flex flex-col items-end shrink-0">
                    <span className="font-heading text-base md:text-lg text-primary-600">{comic.rating}</span>
                    <span className="text-[11px] text-foreground-400">{comic.views}阅读</span>
                  </span>
                </button>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}